<template>
  <div>
    <el-button type="primary" icon="el-icon-plus" @click="dialogVisible = true"
      >添加机器人Info</el-button
    >

    <el-dialog
      title="添加机器人Info"
      width="1200px"
      :visible.sync="dialogVisible"
      @close="closeDialog"
      :before-close="handleClose"
    >
      <div
        style="
          display: flex;
          width: 100%;
          height: 90vh;
          justify-content: space-around;
        "
      >
        <div>
          <h3>Info</h3>
          <el-form
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            label-width="160px"
            class="demo-ruleForm"
          >
            <el-form-item label="huoPair" prop="huoPair">
              <el-input
                v-model.trim="ruleForm.huoPair"
                placeholder="请输入huoPair"
              ></el-input>
            </el-form-item>
            <el-form-item label="fbsPair" prop="fbsPair">
              <!-- <el-input
            v-model.trim="ruleForm.fbsPair"
            placeholder="请输入fbsPair"
          ></el-input> -->
              <el-select v-model="ruleForm.fbsPair" placeholder="请选择" clearable>
                <el-option
                  v-for="item in pairsData"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="mirrorConfig" prop="mirrorConfig">
              <el-input
                v-model.trim="ruleForm.mirrorConfig"
                placeholder="请输入mirrorConfig"
              ></el-input>
            </el-form-item>
            <el-form-item label="bargainConfig" prop="bargainConfig">
              <el-input
                v-model.trim="ruleForm.bargainConfig"
                placeholder="请输入bargainConfig"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="bargainMirrorConfig"
              prop="bargainMirrorConfig"
            >
              <el-input
                v-model.trim="ruleForm.bargainMirrorConfig"
                placeholder="请输入bargainMirrorConfig"
              ></el-input>
            </el-form-item>
            <el-form-item label="userId" prop="userId">
              <el-input
                v-model.trim="ruleForm.userId"
                placeholder="请输入userId"
              ></el-input>
            </el-form-item>
            <el-form-item label="secretKey" prop="secretKey">
              <el-input type="textarea" :rows="4"
                v-model.trim="ruleForm.secretKey"
                placeholder="请输入secretKey"
              ></el-input>
            </el-form-item>
            <el-form-item label="accessKey" prop="accessKey">
              <el-input  type="textarea" :rows="4"
                v-model.trim="ruleForm.accessKey"
                placeholder="请输入accessKey"
              ></el-input>
            </el-form-item>
            <!-- <el-divider></el-divider> -->
            <!-- <el-form-item label-width="120px">
              <el-button type="primary" @click="submitForm('ruleForm')"
                >确定添加</el-button
              >
              <el-button @click="resetForm('ruleForm')">重置</el-button>
            </el-form-item> -->
          </el-form>
        </div>
        <!-- <div style="height: 100%; border-left: 1px solid gray"></div> -->
        <div>
          <h3>Instance</h3>
          <el-form
            :model="instanceForm"
            :rules="rules2"
            ref="instanceForm"
            label-width="120px"
            class="demo-ruleForm"
          >
            <el-form-item label="userId" prop="userId">
              <el-input
                v-model.trim="instanceForm.userId"
                placeholder="请输入instance的userId"
              ></el-input>
            </el-form-item>
            <el-form-item label="secretKey" prop="secretKey">
              <el-input  type="textarea" :rows="4"
                v-model.trim="instanceForm.secretKey"
                placeholder="请输入instance的scretKey"
              ></el-input>
            </el-form-item>
            <el-form-item label="accessKey" prop="accessKey">
              <el-input  type="textarea" :rows="4"
                v-model.trim="instanceForm.accessKey"
                placeholder="请输入instance的accessKey"
              ></el-input>
            </el-form-item>
            <el-form-item label="online（0或1）" prop="online">
              <!-- <el-input
                v-model.trim="instanceForm.online"
                placeholder="请输入instance的状态（0或1）"
              ></el-input> -->
              <el-select v-model="instanceForm.online" placeholder="请选择">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm('ruleForm','instanceForm')">确 定</el-button>
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button @click="resetForm('ruleForm','instanceForm')">重置</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
// import http from ''

export default {
  data() {
    return {
      options: [{
          value: 0,
          label: 0
        }, {
          value: 1,
          label: 1
        }],
      dialogVisible: false,
      ruleForm: {
        //   id: 1,
        huoPair: "",
        fbsPair: "",
        mirrorConfig: "",
        bargainConfig: "",
        bargainMirrorConfig: "",
        userId: "",
        secretKey:
          "",
        accessKey:
          "",
      },
      // ruleForm: {
      //   //   id: 1,
      //   huoPair: "btcusdt--",
      //   fbsPair: "BTC_USDT",
      //   mirrorConfig: "ffff",
      //   bargainConfig: "ggggg",
      //   bargainMirrorConfig: "bargain",
      //   userId: "10010",
      //   secretKey:
      //     "f81858fe95ba0f9d4ca0f528edc5c38489ecafd0d32c6f5c8de7705cf20c0f58",
      //   accessKey:
      //     "892092131a8a591c9198a6da444e0c415e14f182fbfb1f76c7f9371b21daa018",
      // },
      instanceForm: {
        userId:200,
        secretKey:
          "NhqPtmdSJYdKjVHjA7PZj4Mge3R5YNiP1e3UZjInClVN65XAbvqqM6A7H5fATj0j",
        accessKey:
          "vmPUZE6mv9SD5VNHk4HlWFsOr6aKE2zvsw0MuIgwCIPy6utIco14y7Ju91duEh8A",
        online: 0,
      },
      online: 0,
      arr: [],
      result: false,
      rules: {
        id: [{ required: true, message: "请输入id", trigger: "blur" }],
        huoPair: [
          { required: true, message: "请输入huoPair", trigger: "blur" },
        ],
        fbsPair: [
          { required: true, message: "请选择fbsPair", trigger: "change" },
        ],
        mirrorConfig: [
          { required: true, message: "请输入mirrorConfig", trigger: "blur" },
        ],
        bargainConfig: [
          { required: true, message: "请输入bargainConfig", trigger: "blur" },
        ],
        bargainMirrorConfig: [
          {
            required: true,
            message: "请输入bargainMirrorConfig",
            trigger: "blur",
          },
        ],
        userId: [{ required: true, message: "请输入userId", trigger: "blur" }],
        secretKey: [
          { required: true, message: "请输入secretKey", trigger: "blur" },
        ],
        accessKey: [
          { required: true, message: "请输入accessKey", trigger: "blur" },
        ],
        
      },
      rules2:{
      userId: [{ required: true, message: "请输入userId", trigger: "blur" }],
        secretKey: [
          { required: true, message: "请输入secretKey", trigger: "blur" },
        ],
        accessKey: [
          { required: true, message: "请输入accessKey", trigger: "blur" },
        ],
       online: [{ required: true, message: "请输入状态", trigger: "blur" }],
      },
      pairsData: [],
      robotInstance: {
        userId: 215,
        secretKey:
          "NhqPtmdSJYdKjVHjA7PZj4Mge3R5YNiP1e3UZjInClVN65XAbvqqM6A7H5fATj0j",
        accessKey:
          "vmPUZE6mv9SD5VNHk4HlWFsOr6aKE2zvsw0MuIgwCIPy6utIco14y7Ju91duEh8A",
        online: 0,
      },
    };
  },
  async mounted() {
    const re = await this.getPairsData();
    this.pairsData = re.data;
  },
  computed: {
    ...mapState("robot", ["user"]),
  },
  methods: {
    ...mapActions("robot", ["createOne", "getPairsData", "getlist"]),
    handleSave() {
      this.dialogVisible = false;
      this.$message.success("已添加");
    },
    handleClose(done) {
        this.$confirm('还有内容没保存，确认关闭？')
          .then(_ => {
            done();
          })
          .catch(_ => {});
      },
    closeDialog() {},
    // add() {
    //   this.submitForm()
      
    //   // this.dialogVisible=false
    // },
     submitForm(formName,formName1) {
      const infoObj = {
        robotInfo: this.ruleForm,
        robotInstance: {...this.instanceForm},
      };
      this.$refs[formName].validate((valid)=>{
        if(valid){
          this.$refs[formName1].validate(async(valid2)=>{
          if(valid2){
                const res = await this.createOne(infoObj);
            if (res.msg == "success") {
              this.getlist();
              this.dialogVisible = false;
              this.$message.success("添加成功！");
            } else {
              this.$message.error("系统错误！请重试");
            }
          }
        })
     
        }
      })
     
    },
    resetForm(formName,formName1) {
      this.$refs[formName].resetFields();
      this.$refs[formName1].resetFields();
    },
  },
};
</script>

<style lang="less" scoped></style>
